import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import for React 18
import './index.css';
import AppRouter from './Router'; // Assuming Router.js handles the routing
import { EventEmitterContextProvider } from './context/event-emitter.js';
import { getOutboundCallUrl } from './lib/apiConfig.js';

if (typeof window !== 'undefined') {
  console.log('[App] Outbound calls →', getOutboundCallUrl());
}

const root = ReactDOM.createRoot(document.getElementById('root')); // Use createRoot
root.render(
  <EventEmitterContextProvider>
    <AppRouter />
  </EventEmitterContextProvider>
)
